import { render, staticRenderFns } from "./AppChangePassword.vue?vue&type=template&id=1a56a93a&scoped=true&"
import script from "./AppChangePassword.vue?vue&type=script&lang=js&"
export * from "./AppChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./AppChangePassword.vue?vue&type=style&index=0&id=1a56a93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56a93a",
  null
  
)

export default component.exports